<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
	export default {
		name: 'App',
		created() {
			this.checkAuth()
			this.$store.dispatch('GetIPInfo');
		},
		methods: {
			async checkAuth() {
				const token = localStorage.getItem('token')
				if (token && this.$route.path === "/login") {
					try {
						// await api.get('/auth/verify') // 验证token有效性
						this.$router.push('/homePage')
					} catch {
						localStorage.removeItem('token')
					}
				}
			}
		}
	}
</script>

<style>
	* {
		margin: 0;
		padding: 0;
	}


	.el-dialog {
		margin-top: 10vh !important;
	}

	@import url("./assets/global.scss");
</style>